module.exports = __webpack_public_path__ + "img/64-r.da80ad79.png";